import classNames from 'classnames';
import { useLocation, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';

const TabLink = ({ children, href, ...props }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const asPath = location.pathname + location.search;

  const index = asPath.indexOf('?');
  const routerPath = index > 0 ? asPath.substring(0, index) : asPath;
  // href may carry a query string (e.g. ?search=), compare paths only
  const hrefPath = href ? href.split('?')[0] : href;

  const className = classNames('component-border-left', 'tab', {
    'tab-active': routerPath === hrefPath,
  });

  const handleClick = (e) => {
    e.preventDefault();
    navigate(href);
  };

  return (
    <div className={className}>
      <a
        className="tab-link component"
        href={href}
        onClick={handleClick}
        {...props}
      >
        {children}
      </a>
    </div>
  );
};

const Tab = ({ children, label }) => {
  // Use Link's function children pattern to extract href without rendering nested anchors
  if (React.isValidElement(children)) {
    return React.cloneElement(children, {}, ({ href }) => (
      <TabLink href={href}>{label}</TabLink>
    ));
  }
  // Fallback for non-Link children
  return <TabLink>{label}</TabLink>;
};

const Tabs = ({ children }) => (
  <div className="tabs component-bg-white">{children}</div>
);

Tabs.Tab = Tab;

Tab.propsTypes = {
  label: PropTypes.string.isRequired,
};

export default Tabs;
